import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { getApiDatas, urlToHost } from '../../utilities/FrontFunctions/AoxFrontFunctions';


import '../../assets/css/0010_sections/0440_section-recherche.css';

class PageRecherche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiDatas: null,
      search: null,
      searchLimit:100,
    };
   
  }

  fetchData = () => {
    const oParams = queryString.parse(window.location.search);
    if (oParams.search !== undefined && oParams.search !== this.state.search) {
      document.body.classList.add('is-loading')

      getApiDatas(`/apiaox/Call/TestMoteurRechercheV2?isMasterDatabase=false&searchString=${oParams.search}&limit=${this.state.searchLimit}`)
        .then((apiDatas) => {
          this.setState({ apiDatas, search: oParams.search });
          document.body.classList.remove('is-loading')

        });
    }
  };

  componentDidMount() {
    this.fetchData();
    document.body.classList.add('pg_recherche');    //!! ne s'applique pas si MainHeader sClassForPage
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (window.location.search !== prevProps.location?.search) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('pg_recherche');
  }

  
  render() {
    const hasResult = this.state.search && (this.state.apiDatas && Object.entries(this.state.apiDatas).length > 0)

    return (
      <>
        <section className="obj_section section_recherche">
          <div className="ctn_section">
            <div className="ctn_title">
              <h1 className="t_title">{
                this.state.search ?
                  (`Résultats pour '${this.state.search || ""}'`)
                  :
                  "Chargement en cours"
                }
              </h1>
              {(this.state.search && !hasResult) && <p className="t_desc">Nous n'avons pas trouvé de résultat <br/>pour votre recherche.</p>}
            </div>

            {hasResult && (
              Object.entries(this.state.apiDatas).map(([key, item]) => (
                <div className="ctn_recherche" key={key}>
                  <h2 className="t_title">{key}</h2>
                  <ul>
                    {item.map((subItem, index) => (
                      <li key={index}>
                        <Link to={subItem?.Url || "#"}>
                          <img 
                            src={subItem?.BrandLogoUrl
                              ? urlToHost(subItem.BrandLogoUrl) 
                              : require("../../assets/images/v_logo-pa.svg")
                            } 
                            alt="Partner Academy - L'Oréal Beauté Dermatologique" 
                          />
                          <span>{subItem?.Name || "Nom inconnu"}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            )}

          </div>
        </section>
      </>
    )
  }
}

export default withTranslation()(withSitecoreContext()(PageRecherche));
